import * as React from "react";
import * as css from "./Navigator.module.scss";
import { useStaticQuery, graphql, Link } from "gatsby";
import Img from "gatsby-image";
import StrPage from "./StrPage";
import { useContext, useEffect } from "react";
import { useState } from "react";
import { GlobalDispatchContext } from "../context/GlobalContextProvider";

const Navigator = (props) => {
  const dispatch = useContext(GlobalDispatchContext);

  const data = useStaticQuery(
    graphql`
      query {
        allMarkdownRemark(sort: { order: ASC, fields: fields___slug }) {
          edges {
            node {
              id
              fields {
                slug
              }
              frontmatter {
                author
                lang
                interpreter {
                  area
                  name
                  questions {
                    answer
                    question
                  }
                }
                pages {
                  image {
                    childImageSharp {
                      fluid(maxWidth: 200, quality: 90) {
                        ...GatsbyImageSharpFluid_withWebp
                      }
                    }
                  }
                  pins {
                    image {
                      childImageSharp {
                        fluid(maxWidth: 200, quality: 90) {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                    }
                    video
                    x
                    y
                  }
                }
                template
                title
              }
            }
          }
        }
      }
    `
  ).allMarkdownRemark.edges;

  const [entriesEl, setEntriesEl] = useState([]);

  useEffect(() => {
    let els = [];
    function filterItemsByLang(arr, targetLang) {
      return arr.filter(function (item) {
        return item.node.frontmatter.lang === targetLang;
      });
    }

    const filteredData = filterItemsByLang(data, props.lang);

    console.log(`filteredData`, filteredData);

    filteredData.forEach(({ node }, i) => {
      let pageImage = (
        <div
          className={css.navListItem__thumbBox}
          key={`img-${new Date().toString()}`}
        >
          <Img
            fluid={node.frontmatter.pages[0].image.childImageSharp.fluid}
            alt=""
          />
        </div>
      );

      const clsCurrent = window.location.pathname.includes(node.fields.slug)
        ? css.isCurrent
        : "";
      els.push(
        <li key={`entry-${i}`} className={css.navListItem}>
          <Link
            to={node.fields.slug}
            className={`${css.navListItem__aWrap} ${clsCurrent}`}
          >
            <div className={`${css.navListItem__images}`}>{pageImage}</div>

            <div className={`${css.navListItem__texts}`}>
              <p className={`${css.navListItem__texts__title}`}>
                {node.frontmatter.title}
              </p>
              <p className={`${css.navListItem__texts__sub}`}>
                {node.frontmatter.author}
                <br />
                <span className={`${css.pages}`}>
                  <StrPage num={node.frontmatter.pages.length} />
                </span>
              </p>
            </div>
          </Link>
        </li>
      );
    });
    setEntriesEl(els);
  }, [setEntriesEl, data, props.lang]);

  return (
    <div className={`${css.navigator}`}>
      <div className={css.buttonWrap}>
        <button
          aria-label="Hide Navigator"
          className={`${css.hideNavigatorButton}`}
          onClick={() => {
            dispatch({
              type: `HIDE_NAVIGATOR`,
            });
          }}
          title={`Hide Navigator`}
        />
      </div>
      <ul>{entriesEl}</ul>
    </div>
  );
};

export default Navigator;
